import React from 'react'
import { Box, Icon } from '@maui/elements'
import { SearchResultDescription, SearchResultHeader, SearchResultTitle } from '../common'
import { TargetedIndustriesPill } from './ActorSearchResult'
import { ActorAssociationPill } from './IndicatorSearchResult'

export const CampaignSearchResult = ({ data }) => {
  const {
    id,
    name,
    last_activity_time: date,
    description,
    campaign_type: campaignType,
    associatedActors,
    industries
  } = data
  return (
    <Box>
      <SearchResultHeader subHeaderText={campaignType} date={date} />
      <SearchResultTitle
        titleIcon={campaignType === 'Individual' ? <Box pt='4px'><Icon name='bullseye' size='lg' /></Box> : <Icon name='triBullseye' size='lg' color='colorActionPrimary' />}
        name={name}
        url={`/campaigns/${id}`}
      />
      <Box pt='8px' pb='8px'>
        <Box display='flex'>
          <Box>
            <ActorAssociationPill associatedActors={associatedActors}/>
          </Box>
          <Box>
            <TargetedIndustriesPill industries={industries}/>
          </Box>
        </Box>
      </Box>
      <SearchResultDescription description={description}/>
    </Box>
  )
}
